import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, allocatedResourcesBudget }) =>
    present(
      repository
        .updateProjectAllocatedResourcesBudget(
          project,
          allocatedResourcesBudget,
        )
        .then(() => ({ project, allocatedResourcesBudget }))
        .catch(() => Promise.reject({ project, allocatedResourcesBudget })),
    );
}

export type { Interactor };

export { createInteractor };
